import React from 'react';
import { Routes, Route, } from 'react-router-dom';
import './App.css';



import Login from './components/Login/Login';
import 'bootstrap/dist/css/bootstrap.min.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//import Productos from './components/lista/lista2';
import TablaMaterias from './components/Tablas/TablaMaterias';
import ProductosG from './components/lista/lista2';
import EmpleadosList from './components/calificacion/empleados';
import LandingPage from './components/LandingPage/LandingPage';



function App() {


  return (
    <div className="App">

      <ToastContainer></ToastContainer>
      <Routes>

        <Route path="/" exact element={<ProductosG />} />
        <Route path="/inicio" exact element={<LandingPage />} />
        <Route path="/dashboard" exact element={<TablaMaterias />} />
        <Route path="/login" exact element={<Login />} />
        <Route path="/empleados" exact element={<EmpleadosList />} />








      </Routes>
    </div>
  );
}

export default App;
